var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "list",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M1.5,17C2.3,17,3,17.7,3,18.5S2.3,20,1.5,20S0,19.3,0,18.5S0.7,17,1.5,17z M1.5,10C2.3,10,3,10.7,3,11.5S2.3,13,1.5,13  S0,12.3,0,11.5S0.7,10,1.5,10z M1.5,3C2.3,3,3,3.7,3,4.5S2.3,6,1.5,6S0,5.3,0,4.5S0.7,3,1.5,3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--white",
    d: "M22.5,20h-14C7.7,20,7,19.3,7,18.5l0,0C7,17.7,7.7,17,8.5,17h14c0.8,0,1.5,0.7,1.5,1.5l0,0C24,19.3,23.3,20,22.5,20z   M22.5,13h-14C7.7,13,7,12.3,7,11.5l0,0C7,10.7,7.7,10,8.5,10h14c0.8,0,1.5,0.7,1.5,1.5l0,0C24,12.3,23.3,13,22.5,13z M22.5,6h-14  C7.7,6,7,5.3,7,4.5l0,0C7,3.7,7.7,3,8.5,3h14C23.3,3,24,3.6,24,4.5l0,0C24,5.3,23.3,6,22.5,6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.bfca23c5.svg";
export { ForwardRef as ReactComponent };